import loadable from '@nordvpn/teams.core/lib/tools/loadable';
// Lazy page entries, mounted by CustomPlansManagementRouting behind the
// PackageProductSelection feature flag.
export var PackageCreate = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/PackageCreate');
});
export var PackageEdit = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/PackageEdit');
});
// Replaces the legacy CustomPackagesList / PartnerPackagesList behind PackagesListRedesign.
export var PackagesList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/PackagesList');
});
